/* PROTOCOL flow v6 · rail parity

   join-protocol renders the rail as <div id="rail" class="rail collapsible">.
   add-ons and renew render it as <div id="rail" class="rail">.

   Every mobile rule in the theme is written against .rail.collapsible, so on
   add-ons and renew the summary never collapses and the "view" control in the
   mobile bar toggles a class nothing listens to. Tapping it does nothing,
   which is the same fault join-protocol had before the bottom sheet went in.

   Adding the class gives all three flows identical mobile behaviour: the
   mobile bar carries the total, and "view" raises the summary as a sheet. */
(function(){
  'use strict';
  function apply(){
    var rail = document.getElementById('rail');
    if(rail && !rail.classList.contains('collapsible')){
      rail.classList.add('collapsible');
    }
  }
  apply();
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', apply);
  }
  /* configureRail rewrites className on step changes, so reassert it */
  setTimeout(apply, 400);
  setTimeout(apply, 1200);
  var r = document.getElementById('rail');
  if(r) new MutationObserver(apply).observe(r, {attributes:true, attributeFilter:['class']});
})();
